import { Stack } from '@mui/material';

import Pill from '../../../../../components/Pill';
import {
  HeroSection,
  HeroContainer,
  HeroTitle,
  HeroSubtitle,
  HeroText,
  HeroTextSecondary,
  PillsContainer,
  pillStyles,
  pillTextStyles,
} from './styles';
import { HERO_CONTENT, PILLS } from './constants';

const HeroSectionComponent = () => {
  return (
    <HeroSection>
      <HeroContainer>
        <Stack>
          <HeroTitle as="h1">
            {HERO_CONTENT.title.split('\n')[0]}
            <br />
            {HERO_CONTENT.title.split('\n')[1]}
          </HeroTitle>

          <HeroSubtitle>{HERO_CONTENT.subtitle}</HeroSubtitle>

          <HeroText>{HERO_CONTENT.text}</HeroText>

          <HeroTextSecondary>{HERO_CONTENT.textSecondary}</HeroTextSecondary>

          <PillsContainer>
            {PILLS.map((pill, index) => (
              <Pill key={index} pillStyles={pillStyles} sx={pillTextStyles}>
                {pill}
              </Pill>
            ))}
          </PillsContainer>
        </Stack>
      </HeroContainer>
    </HeroSection>
  );
};

export default HeroSectionComponent;
